import axios from '@/services/axiosConfig'

/**
 * instId : 기관 아이디
 */

const endPoint = {
	createLocation: instId => `/institute/${instId}/location`,
	lookupLocationTree: instId => `/institute/${instId}/location/tree`,
	lookupLocationDetail: (instId, locationId) =>
		`/institute/${instId}/location?id=${locationId}`,
	updateLocation: instId => `/institute/${instId}/location`,
	deleteLocation: (instId, locationId) =>
		`/institute/${instId}/location?id=${locationId}`,
}

const locationAPI = {
	createLocation: (instId, data) =>
		axios.post(endPoint.createLocation(instId), data),
	lookupLocationTree: instId =>
		axios.get(endPoint.lookupLocationTree(instId)),
	lookupLocationDetail: (instId, locationId) =>
		axios.get(endPoint.lookupLocationDetail(instId, locationId)),
	updateLocation: (instId, data) =>
		axios.put(endPoint.updateLocation(instId), data),
	deleteLocation: (instId, locationId) =>
		axios.delete(endPoint.deleteLocation(instId, locationId)),
}

export default locationAPI
